import React from "react"
import propTypes from "prop-types"

const Content = ({ children, elRef }) => {
  return (
    <div ref={elRef} className="accordion_content">
      {children}
    </div>
  )
}

Content.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  elRef: propTypes.func
}

Content.defaultProps = {
  elRef: () => {}
}

export default Content
